<div class="container-fluid">
    <div class="row">
        <div class="col-md-3">
            <a routerLink="/naac/aqar/2023-24"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
            <nav id="secondary-navigation">
                <!-- Header -->
                <header class="header">
                    <h5>CRITERION-6</h5>
                </header>
                <!-- /Header -->
                <ul>
                    <li routerLinkActive="active">
                        <a  routerLink="/naac/aqar/2023-24/criteria6/6-1-2">6.1.2</a>
                    </li>
                   
                </ul>
            </nav>
        </div>
        <div class="col-md-9">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>